import { render, staticRenderFns } from "./scertificate.vue?vue&type=template&id=169c23a8&scoped=true&"
import script from "./scertificate.vue?vue&type=script&lang=js&"
export * from "./scertificate.vue?vue&type=script&lang=js&"
import style0 from "./scertificate.vue?vue&type=style&index=0&id=169c23a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169c23a8",
  null
  
)

export default component.exports